module.exports = __webpack_public_path__ + "img/download-play.119f749b.png";